class DestinationTabs {
    constructor(container) {
        this.container = container;
        if (!this.container) return;

        this.navItems = this.container.querySelectorAll('.destination-tabs__nav-item');
        this.tabPanes = this.container.querySelectorAll('.destination-tab-pane');

        this.init();
    }

    init() {
        this.navItems.forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab));
        });
    }

    switchTab(tab) {
        const tabId = tab.dataset.tab;

        this.navItems.forEach(t => t.classList.remove('active'));
        this.tabPanes.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');
        const pane = this.container.querySelector('#tab-' + tabId);
        if (pane) pane.classList.add('active');
    }
}

export default DestinationTabs;
